/**
 * Will return the wanted text section
 * @param {object} obj - Collection of texts
 * @param {string} path - Key path to the value
 */
const getPropValueAtPath = (obj = {}, path) => {
  const result = obj;
  const sections = path.split('.');
  const nextSection = sections[0];

  if (sections.length > 1) {
    return getPropValueAtPath(result[nextSection], sections.slice(1).join('.'));
  }

  return result[nextSection];
};

/**
 * Manage text with dynamic values
 */
export const TextManager = (function textManager() {
  function Manager(texts) {
    this.texts = texts;
  }

  /**
   * Replace variables in text
   * @param {string} text - Original unparsed text
   * @param {Object|Array} variables - Key, value mapping of variables to be replaced
   */
  Manager.prototype.replace = function replace(text, variables) {
    if (Array.isArray(variables)) {
      let collectText = text;
      variables.forEach((variable) => {
        // eslint-disable-next-line array-callback-return
        Object.keys(variable).reduce((string, key) => {
          const regex = new RegExp(`{{${key}}}?`, 'g');
          collectText = string.replace(regex, variable[key]);
        }, collectText);
      });

      return collectText;
    }

    return Object.keys(variables).reduce((string, key) => {
      const regex = new RegExp(`{{${key}}}?`, 'g');
      return string.replace(regex, variables[key]);
    }, text);
  };

  /**
   * Get text
   * @param {string} path - Key path to the value
   * @param {Object|Array} variables - Key, value mapping of variables to be replaced
   */
  Manager.prototype.get = function get(path, variables) {
    const text = getPropValueAtPath(this.texts, path);

    if (typeof text === 'undefined' || text === null) {
      return '';
    }

    if (!variables) {
      return text;
    }

    return this.replace(text, variables);
  };

  return Manager;
})();
